import { isZeroDecimalCurrency } from './isZeroDecimalCurrency';

export function amountFromBaseUnits(amount: number, currency: string): number {
	return Number(isZeroDecimalCurrency(currency) ? amount : amount / 100);
}
